'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = void 0;

var _jsxRuntime = require('react/jsx-runtime');

var _react = require('react');

var _propTypes = _interopRequireDefault(require('prop-types'));

var _lodash = _interopRequireDefault(require('lodash'));

var _reactAdmin = require('react-admin');

var _reactFinalForm = require('react-final-form');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(
          target,
          key,
          Object.getOwnPropertyDescriptor(source, key)
        );
      });
    }
  }
  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/**
 * A custom ReferenceInput that update its props (e.g. `filter`, `disabled`) depend on another input
 * which is specified by `dependencySource`
 *
 * @example
 *
 *   <DependentReferenceInput
 *      dependentSource="state_id"
 *      dependentFilter={(dependencyValue) => ({
 *        state_id: dependencyValue,
 *      })}
 *      source="city_id"
 *      reference="locale/cities"
 *      sort={{
 *        field: 'name',
 *        order: 'ASC',
 *      }}
 *    >
 *      <SelectInput />
 *    </DependentReferenceInput>
 *
 */
var DependentReferenceInput = function DependentReferenceInput(props) {
  var dependencySource = props.dependencySource,
    dependencyToFilter = props.dependencyToFilter,
    dependencyToDisabled = props.dependencyToDisabled,
    rest = _objectWithoutProperties(props, [
      'dependencySource',
      'dependencyToFilter',
      'dependencyToDisabled',
    ]);

  var source = rest.source,
    propDisabled = rest.disabled,
    _rest$filter = rest.filter,
    filter = _rest$filter === void 0 ? {} : _rest$filter;
  var form = (0, _reactFinalForm.useForm)();

  var _useFormState = (0, _reactFinalForm.useFormState)(),
    values = _useFormState.values;

  var dependencyValue = _lodash.default.get(values, dependencySource);

  var dependencyValueRef = (0, _react.useRef)(dependencyValue);

  var mergedFilter = _objectSpread(
    {},
    filter,
    {},
    dependencyToFilter ? dependencyToFilter(dependencyValue) : {}
  );

  var disabled = dependencyToDisabled
    ? dependencyToDisabled(dependencyValue)
    : propDisabled;
  (0, _react.useEffect)(
    function () {
      // clear the input if the dependency is changed
      if (dependencyValueRef.current !== dependencyValue) {
        form.change(source, undefined);
        form.resetFieldState(source);
        dependencyValueRef.current = dependencyValue;
      }
    },
    [form, dependencyValue, source]
  );
  return /*#__PURE__*/ (0, _jsxRuntime.jsx)(
    _reactAdmin.ReferenceInput,
    _objectSpread({}, rest, {
      disabled: disabled,
      filter: mergedFilter,
    })
  );
};

DependentReferenceInput.propTypes = {
  /**
   * The `source` on which this input depends
   */
  dependencySource: _propTypes.default.string.isRequired,

  /**
   * A callback that transfers the value of the dependency to `disabled` prop of the ReferenceInput
   */
  dependencyToDisabled: _propTypes.default.func,

  /**
   * A callback that transfers the value of the dependency to `filter` prop of the ReferenceInput
   */
  dependencyToFilter: _propTypes.default.func,
};
var _default = DependentReferenceInput;
exports.default = _default;

//# sourceMappingURL=index.js.map
